<template>
  <div
    v-if="center.lat === 0 || center.lng === 0"
    class="loading-layout"
  >
    <v-progress-circular
      :size="50"
      color="primary"
      indeterminate
    ></v-progress-circular>
  </div>
  <div v-else>
    <gmap-map
      ref="mapRef"
      :center="mapOptions.center"
      :zoom="mapOptions.zoom"
      :options="mapOptions.option"
      style="width: 100%; height: 400px"
    >
      <gmap-marker
        ref="myMarker"
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        :title="m.title"
        :icon="
          m.isActive
            ? require(`@/assets/images/google-map/${checkMarker(
                m.type,
              )}-bk.svg`)
            : require(`@/assets/images/google-map/${checkMarker(
                m.type,
              )}-wh.svg`)
        "
        :clickable="true"
        @click="onClickMapMarker(m, index)"
      ></gmap-marker>
      <gmap-info-window
        :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen = false"
      >
      </gmap-info-window>
    </gmap-map>
  </div>
</template>

<script>
import STORE_BRANCH_TYPE from '@/enums/storeBranchType'

export default {
  props: {
    data: Object,
  },

  computed: {
    mapOptions() {
      return {
        zoom: 8,
        center: this.center,
        option: {
          mapTypeControl: false,
          streetViewControl: false,
        },
      }
    },
  },

  data() {
    return {
      center: { lat: 0, lng: 0 },
      markers: [],
      places: [],
      currentPlace: null,
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        content: '',
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
    }
  },

  mounted() {
    this.geolocate()
    this.addMarker()
  },

  methods: {
    onClickMapMarker(marker, index) {
      //   console.log('marker', marker, this.$refs.mapRef)
      this.center = marker.position

      this.infoWindowPos = marker.position
      this.infoOptions.content = marker.title
      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == index) {
        this.infoWinOpen = !this.infoWinOpen
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true
        this.currentMidx = index
      }
    },

    // setPlace(place) {
    //   this.currentPlace = place
    // },
    addMarker() {
      //   if (this.currentPlace) {
      for (const item of this.data) {
        const marker = {
          lat: +item.lat,
          lng: +item.lng,
        }
        this.markers.push({
          position: marker,
          label: item.branch_name,
          title: item.branch_name,
          isActive: true,
          type: this.getTypeMarker(item.branch_name),
        })
      }

      // this.places.push(this.currentPlace)
      //   this.center = marker
      //   this.currentPlace = null
      //   }
    },

    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        }
      })
    },

    getTypeMarker(val) {
      const name = val.toUpperCase()
      if (name.includes('สำนักงานใหญ่')) {
        return 'com7'
      } else if (name.includes('BN')) {
        return 'banana'
      } else if (name.includes('BB')) {
        return 'bb'
      } else if (name.includes('STUDIO')) {
        return 'studio-7'
      } else {
        return 'com7'
      }
    },

    checkMarker(marker) {
      const storeBranchTypeValues = Object.values(STORE_BRANCH_TYPE)
      if (storeBranchTypeValues.includes(marker)) {
        return marker
      }

      return STORE_BRANCH_TYPE.BANANA
    },
  },
}
</script>

<style lang="stylus" scoped>
.loading-layout
  display: flex
  justify-content: center
  align-items: center
  width: 100%;
  height: 400px
  background: #DCDCDC
</style>
